import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import {
    chipAggregatedLabel,
    chipItemLabel,
    renderCollectionChips,
    useChipFiltersStore,
} from "../BaseChipComponents/chipUtils";

export const PrimaryDriversChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const drivers = applicationFiltersStore.drivers;
    const isExclusion = !applicationFiltersStore.containsDrivers;
    const setDriversAndNormalizeMode = (nextDrivers: typeof drivers) => {
        applicationFiltersStore.setDrivers(nextDrivers);
        if (isExclusion && nextDrivers.length === 0)
            applicationFiltersStore.setContainsDrivers(true);
    };

    return renderCollectionChips({
        items: drivers,
        disabled: props.disabled,
        isApplicable: props.isApplicable,
        getKey: (driver) => driver.driverIndex,
        getLabel: (driver) =>
            chipItemLabel("Driver", driver.driverName, isExclusion),
        getTooltipLabel: (driver) => driver.driverName,
        getAggregatedLabel: (count) =>
            chipAggregatedLabel(count, "Drivers", isExclusion),
        onRemoveAll: () => setDriversAndNormalizeMode([]),
        onRemoveItem: (driver) =>
            setDriversAndNormalizeMode(
                applicationFiltersStore.drivers.filter(
                    (item) => item.driverIndex !== driver.driverIndex,
                ),
            ),
    });
});
